<template>
  <div class="vh-100 d-flex flex-column">
    <component :is="`${header_type}-header`" />
    <div class="row g-0 flex-grow">
      <!-- Левый сайдбар -->
      <div
        class="sidebar-container col-12 col-xl-3 border-end border-mobile-none border-warning d-flex flex-column"
        :class="theme == 'light' ? 'bg-secondary' : 'bg-primary'"
      >
        <!-- Внутренний контейнер для скролла -->
        <div class="flex-grow-1 ps-2 pe-2">
          <DashboardStartNavbar
            :navs="navs"
            :active="active"
            @changeTheme="$emit('changeTheme', $event)"
            @changeActive="active = $event"
          />
        </div>
      </div>

      <!-- Основной контент -->
      <div class="sidebar-container col-12 col-xl-9 d-flex flex-column">
        <div class="flex-grow-1 d-flex flex-column">
          <router-view @changeNavs="changeNavs" :active="active" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { theme } from "@/store/modules/theme";
import DashboardStartNavbar from "../app/dashboard-start-navbar.vue";
import ClassicalHeader from "../app/headers/classical-header.vue";

import type { DashboardNav } from "@/@types/layouts_nav/dashboard";

@Options({
  name: "dashboard-layout",
  components: { DashboardStartNavbar, ClassicalHeader },
})
class DashboardLayout extends Vue {
  navs: DashboardNav[] = [];
  active = "";
  header_type = "classical";

  get theme(): string {
    return theme().getTheme;
  }

  changeNavs(navs: DashboardNav[]): void {
    this.navs = navs;
    if (this.navs.length) this.active = this.navs[0].id;
  }
}
export default DashboardLayout;
</script>
<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";

.navbar {
  border-bottom: 1px solid $warning;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 74px;

  &.navbar-scrolled {
    padding: 0.8rem 0;
  }
}

.navbar-brand {
  transition: all 0.3s ease;
}

.brand-logo {
  transition: transform 0.3s ease;
  .navbar-brand:hover & {
    transform: scale(1.05);
  }
}

/* Сбрасываем padding для Bootstrap колонок */
.sidebar-container {
  padding: 0 !important;
  height: 100%;
}

/* Убедимся, что у хедера есть фиксированная высота */
:deep(.header-component) {
  flex-shrink: 0;
}

@media (max-width: 1200px) {
  .border-mobile-none {
    border: none !important;
  }
  .sidebar-container {
    padding: 0 !important;
    height: auto;
  }
}

@media (min-width: 1200px) {
  .flex-grow {
    flex-grow: 1;
  }
}
</style>
